import { useTranslation } from 'react-i18next';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import getLocalisedTime from 'utils/times/getLocalisedTime';
import { checkIsPastSectionUnlockDateTime, getDateAndTimeFromDateTime } from 'screens/SectionEditorModal/utils';
var dateOptions = {
  month: 'numeric',
  year: 'numeric',
  day: 'numeric'
};
export function useLockingInfoText(_ref) {
  var section = _ref.section,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? 'user' : _ref$context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  switch (section.lockingMode) {
    case null:
      return undefined;
    case 'locked':
      return t('section_locked_status_locked');
    case 'progress':
      return t('section_locked_status_progress', {
        context: context
      });
    case 'time':
      {
        var _getDateAndTimeFromDa = getDateAndTimeFromDateTime(section.unlockDateTime),
          date = _getDateAndTimeFromDa.date,
          time = _getDateAndTimeFromDa.time;
        var isPastUnlockTime = checkIsPastSectionUnlockDateTime(section.lockingMode, date, time, section.unlockTimezone);
        return t(isPastUnlockTime ? 'section_locked_status_datetime_past' : 'section_locked_status_datetime_future', {
          date: getLocalisedDate({
            date: date,
            isInLocalTimezone: true,
            options: dateOptions
          }),
          time: time ? getLocalisedTime(time) : undefined
        });
      }
  }
}